// A module to forge IDs for Refract elements.
'use strict';

var _createClass = require('babel-runtime/helpers/create-class')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

var _slug = require('slug');

var _slug2 = _interopRequireDefault(_slug);

_slug2['default'].defaults.mode = 'rfc3986';

var Abagnale = (function () {
  function Abagnale(options) {
    _classCallCheck(this, Abagnale);

    this.options = options;

    if (this.options === undefined) {
      this.options = {};
    }

    if (this.options.separator === undefined) {
      this.options.separator = '.';
    }

    if (this.options.uriSeparator === undefined) {
      this.options.uriSeparator = '/';
    }

    this.cache = {};
  }

  /*
    Get a unique ID, given an input ID as a base. If it has already been used,
    then a number (starting at `2`) is appended until an unused ID is found.
    Returns the first available ID.
  */

  _createClass(Abagnale, [{
    key: 'getUnique',
    value: function getUnique(id) {
      var number = 2;

      if (this.cache[id] === undefined) {
        this.cache[id] = true;
        return id;
      }

      var name = id + '-' + number;
      while (this.cache[name]) {
        number++;
        name = id + '-' + number;
      }

      this.cache[name] = true;
      return name;
    }

    /*
      Get a key for an array element or object member. The key can either be
      the index, element name, member key value, element title, or element
      class name depending on what makes the most sense. This can be used to
      give paths like `api.parts.frob.get-a-frob.httptransaction.httpresponse`,
      which is nicer than `category.0.0.0.0.0` when just using array indexes.
      The selected slugified key is returned.
    */
  }, {
    key: 'keyForArray',
    value: function keyForArray(index, refract) {
      var key = undefined;

      switch (refract.element) {
        case 'boolean':case 'string':case 'number':case 'array':
        case 'enum':case 'object':
          // Basic types just default to the index value.
          key = index;
          break;
        default:
          // Non-basic types default to the element name, e.g. `resource`.
          key = (0, _slug2['default'])(refract.element);
      }

      // If this is a member and the key is a string, use the key value.
      if (refract.content && refract.content.key && refract.content.key.element === 'string') {
        key = (0, _slug2['default'])(refract.content.key.content);
      }

      // If there is a title or a *single* class name, use that instead as it
      // should contain more specific and relevant information.
      if (refract.meta) {
        if (refract.meta.title) {
          key = (0, _slug2['default'])(refract.meta.title);
        } else if (refract.meta.classes && refract.meta.classes.length === 1) {
          key = (0, _slug2['default'])(refract.meta.classes[0]);
        }
      }

      return key;
    }

    /*
      Get an ID for an element, based on the current path, any existing ID,
      and any element class name. An existing ID will trump other values and
      resets the path. Returns the unique ID to use.
    */
  }, {
    key: 'idForElement',
    value: function idForElement(path, refract) {
      var newPath = path;

      if (refract.meta) {
        if (refract.meta.id) {
          newPath = [refract.meta.id];
        } else if (path.length === 0 && refract.meta.classes && refract.meta.classes.length === 1) {
          // This is the first item, and it has a class name, so we use that.
          newPath = [refract.meta.classes[0]];
        }
      }

      var id = newPath.join(this.options.separator);

      if (!id) {
        id = refract.element;
      }

      return this.getUnique(id);
    }

    /*
      Forge an ID for a single refract structure and any children in-place.
    */
  }, {
    key: 'forgeOne',
    value: function forgeOne(path, refract) {
      if (!refract.meta) {
        refract.meta = {};
      }

      refract.meta.id = this.idForElement(path, refract);

      if (!refract.meta.links) {
        refract.meta.links = [];
      }

      refract.meta.links.push({
        element: 'link',
        content: {
          relation: 'uri-fragment',
          href: refract.meta.id.split(this.options.separator).map(function (item) {
            return (0, _slug2['default'])(item);
          }).join(this.options.uriSeparator)
        }
      });

      // Array like content containing elements?
      if (refract.content && refract.content.length && refract.content[0].element) {
        for (var i = 0; i < refract.content.length; i++) {
          var item = refract.content[i];
          var key = this.keyForArray(i, item);
          var newPath = [refract.meta.id, key].join(this.options.separator);

          switch (item.element) {
            case 'ref':
              // Skip includes as the included object will have its own
              // ID already.
              continue;
            case 'member':
              // Probably object members
              this.forgeOne([newPath + '-member'], item);
              this.forgeOne([newPath + '-key'], item.content.key);
              this.forgeOne([newPath], item.content.value);
              break;
            default:
              // Probably array or enum items
              this.forgeOne([newPath], item);
          }
        }
      }

      return refract;
    }

    /*
      Forge IDs for an array of refract structures.
    */
  }, {
    key: 'forge',
    value: function forge(structures) {
      for (var i = 0; i < structures.length; i++) {
        this.forgeOne([], structures[i]);
      }

      return structures;
    }
  }]);

  return Abagnale;
})();

module.exports = {
  Abagnale: Abagnale,
  forge: function forge(structures, options) {
    var abagnale = new Abagnale(options);
    return abagnale.forge(structures);
  }
};
//# sourceMappingURL=abagnale.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/abagnale/lib/abagnale.js
 ** module id = 1146
 ** module chunks = 0
 **/